module.exports = __webpack_public_path__ + "media/images/delete-8b79ff2cd2ef47249a4172459e3256a8.svg";